import Btn from "../utils/btn";

const func = ($target) => {
	console.log("Rocket Chat Loaded");

	var $token = $target.data("token"),
		$inviteModal = $target.find("#inviteModal"),
		$newEmailForm = $inviteModal.find('[data-id="new-email-form"]'),
		$inviteEmails = $inviteModal.find('[data-id="invite-emails"]'),
		$inviteForm = $inviteModal.find('[data-id="invite-form"]'),
		$teamModal = $target.find("#teamModal"),
		$selectTeamForm = $teamModal.find('[data-id="select-team-form"]'),
		$teamNames = $teamModal.find('[data-id="team-names"]'),
		$teamForm = $teamModal.find('[data-id="team-form"]');

	// user invite
	$newEmailForm.on("submit", function (e) {
		e.preventDefault();

		var $this = $(this),
			$email = $this.find('[name="email"]'),
			$submit = new Btn($this.find('button[type="submit"]')),
			$emails = $inviteForm.find($('input[value="' + $email + '"]'));

		if ($emails[0] === undefined) {
			$inviteEmails.append(
				'<div data-id="' +
					$email.val() +
					'"><small>' +
					$email.val() +
					'</small> <a href="#" data-type="remove">X</a> </div>'
			);
			$inviteForm.append(
				'<input type="hidden" name="emails[]" value="' +
					$email.val() +
					'">'
			);
		}
		$email.val("");

		$inviteForm.find('button[type="submit"]').removeAttr("disabled");

		$submit.processed();
	});

	// team invite
	$selectTeamForm.on("submit", function (e) {
		e.preventDefault();

		var $this = $(this),
			$team = $this.find('[name="team"]'),
			$selectedTeam = $this.find(":selected"),
			$submit = new Btn($this.find('button[type="submit"]')),
			$teamIds = $teamForm.find(
				$('input[value="' + $selectedTeam + '"]')
			);

		if ($teamIds[0] === undefined) {
			$teamNames.append(
				'<div data-id="' +
					$selectedTeam.val() +
					'"><small>' +
					$selectedTeam.text() +
					'</small> <a href="#" data-type="remove">X</a> </div>'
			);
			$teamForm.append(
				'<input type="hidden" name="teamIds[]" value="' +
					$selectedTeam.val() +
					'">'
			);
		}

		$team.prop("selectedIndex", 0);

		$teamForm.find('button[type="submit"]').removeAttr("disabled");

		$submit.processed();
	});

	// delete user/teams added to invite lists
	$('[data-id="invite-emails"],[data-id="team-names"]').on(
		"click",
		'[data-type="remove"]',
		function (e) {
			e.preventDefault();

			var $this = $(this),
				$id = $this.closest("div").data("id"),
				num = $this
					.closest('[data-id="invite-emails"],[data-id="team-names"]')
					.find('[data-type="remove"]').length;

			if (num - 1 == 0) {
				// console.log($this.closest('.modal-content').find('.modal-footer'));
				$this
					.closest(".modal-content")
					.find('.modal-footer button[type="submit"]')
					.prop("disabled", true);
			}

			$target.find($('input[value="' + $id + '"]')).remove();
			$target.find('[data-id="' + $id + '"]').remove();
		}
	);

	window.addEventListener("message", (e) => {
		// Process message event
		switch (e.data.eventName) {
			case "new-message":
				console.log("new-message");
				console.log(e.data.data);
				break;
			default:
				break;
		}
	});

	// window.onload = function () {
	// 	authenticateIFrame($token);
	// };

	window.onload = function () {
		setTimeout(() => { authenticateIFrame($token) }, 2000);
	};

	function authenticateIFrame(loginToken) {
		document.getElementById("rc-channel").contentWindow.postMessage(
			{
				externalCommand: "login-with-token",
				token: loginToken,
			},
			"*"
		);
	}
};

export default func;
